import { LinkText } from 'common/src/designSystem/components/linkText';
import { Cell } from 'common/src/designSystem/components/table/cell';
import { VolunteerRegistrationFragment } from 'common/src/generated/types';
import { isNonEmptyString } from 'common/src/util/string';
import * as React from 'react';

interface IVolunteerRegistrationShortTagCellProps {
    volunteerRegistration: VolunteerRegistrationFragment;
}

export const VolunteerRegistrationShortTagCell = (
    props: IVolunteerRegistrationShortTagCellProps
) => (
    <Cell>
        {isNonEmptyString(props.volunteerRegistration.shortTag) &&
        isNonEmptyString(props.volunteerRegistration.weezeventPayUrl) ? (
            <LinkText
                css={{ fontWeight: 'normal' }}
                to={props.volunteerRegistration.weezeventPayUrl}
            >
                {props.volunteerRegistration.shortTag}
            </LinkText>
        ) : (
            props.volunteerRegistration.shortTag || ''
        )}
    </Cell>
);
